import React from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/GlobalFooter.css';

const legalLinks = [
  { label: 'Privacy Policy', href: '/legal#privacy' },
  { label: 'Terms of Use', href: '/legal#terms' },
  { label: 'Cookie Policy', href: '/legal#cookies' },
];

const GlobalFooter = ({ onManageCookies }) => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const isAdminRoute = path.startsWith('/admin') || path.startsWith('/business-admin');
  const isAnalyticsRoute = path.startsWith('/analytics');
  const isResponseRoute = /^\/(share\/)?survey\/[^/]+(\/[^/]+)?$/.test(path);
  const isBuilderRoute =
    path.startsWith('/survey-builder') ||
    path.startsWith('/create-survey') ||
    path.startsWith('/savedsurveys') ||
    path.startsWith('/survey-dashboard') ||
    path.startsWith('/survey-editor') ||
    path.startsWith('/ai-chat') ||
    path.startsWith('/survey-builder/guided') ||
    path.startsWith('/survey-builder/quick');

  // Light everywhere except the public response experience.
  const useLightTheme = !isResponseRoute && (isAdminRoute || isAnalyticsRoute || isBuilderRoute);
  const footerClassName = `global-footer${useLightTheme ? ' global-footer--light' : ''}`;

  return (
    <footer className={footerClassName}>
      <div className="global-footer__inner">
        <div className="global-footer__brand">
          <span className="global-footer__logo">Eclipseer</span>
          <span className="global-footer__tagline">Customer feedback, simplified.</span>
        </div>
        <div className="global-footer__links">
          {legalLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="global-footer__link"
            >
              {link.label}
            </a>
          ))}
          <button type="button" className="global-footer__link global-footer__link-button" onClick={onManageCookies}>
            Manage Cookies
          </button>
        </div>
        <div className="global-footer__meta">
          <span>© {new Date().getFullYear()} Eclipseer.</span>
          <span className="global-footer__divider">•</span>
          <span>All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
